<template>
    <div>
        <h2>Welcome</h2>
        <p>{{ $route.path }}</p>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    computed: {},
    methods: {},
    created() {},
};
</script>
<style lang="scss">
</style>